import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faTrash } from '@fortawesome/free-solid-svg-icons';
import api from '../../services/api';

// Permanent deletion of an espace already in the bin. Two checks before anything happens: the espace's
// exact name, and the owner's password (verified by the dashboard login service, which returns a
// 5-minute token for this one action). The server checks both again.
const PurgeGroupDialog = ({ group, onClose, onPurged }) => {
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const nameMatches = name.trim() === group.nom.trim();

  const purge = async () => {
    if (!nameMatches || !password || busy) return;
    setBusy(true);
    setError(null);
    try {
      const confirmation = await api.post('/dashboard-admin/confirm-password', {
        password,
        purpose: 'purge-group',
      });
      const response = await api.delete(`/dashboard-admin/purge-group/${group.id}`, {
        data: { confirmToken: confirmation.data.confirmToken, confirmName: name.trim() },
      });
      onPurged(response.data);
    } catch (e) {
      setError(e.response?.data?.error || 'Erreur lors de la suppression définitive');
      setBusy(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={() => !busy && onClose()}>
      <div className="modal-content purge-modal" onClick={(e) => e.stopPropagation()}>
        <div className="purge-header">
          <FontAwesomeIcon icon={faExclamationTriangle} />
          <h3>Supprimer définitivement</h3>
        </div>

        <div className="modal-body">
          <p className="purge-warning">
            <strong>{group.nom}</strong> et <strong>toutes ses données</strong> (membres, produits, ventes,
            abonnements, appareils, sauvegarde cloud) seront effacés. <strong>Cette action est irréversible</strong> :
            seule la sauvegarde nocturne de la base permettrait de revenir en arrière.
          </p>

          <label htmlFor="purge-name">
            Tapez le nom de l'espace pour confirmer : <code>{group.nom}</code>
          </label>
          <input
            id="purge-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoComplete="off"
            autoFocus
            disabled={busy}
          />

          <label htmlFor="purge-password">Votre mot de passe</label>
          <input
            id="purge-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && purge()}
            autoComplete="current-password"
            disabled={busy}
          />

          {error && <p className="purge-error">{error}</p>}
        </div>

        <div className="modal-actions">
          <button className="btn-cancel" onClick={onClose} disabled={busy}>Annuler</button>
          <button className="btn-purge" onClick={purge} disabled={!nameMatches || !password || busy}>
            {busy ? <span className="spinner-small"></span> : <><FontAwesomeIcon icon={faTrash} /> Supprimer définitivement</>}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PurgeGroupDialog;
